import z from 'zod';

/**
 * Enum representing the parent table of a given record.
 * This is used to indicate the parent table in the database
 * to which a record is related. It helps in associating a record
 * with a record from any of the specified tables.
 */
export const parentTableEnumSchema = z.enum([
  'contracts',
  'contacts',
  'payments',
  'attachments',
  'communication',
]);

export type ParentTableEnum = z.infer<typeof parentTableEnumSchema>;
